import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { establishSession } from './auth';
import { loadConfig } from './config';
import './styles.css';

const container = document.getElementById('root');

if (!container) throw new Error('Missing #root element.');

const root = createRoot(container);

/**
 * Login is resolved before the app renders, so no view ever has to handle the
 * "signed out" case. establishSession either returns a session or navigates to
 * the Cognito hosted UI.
 */
async function start() {
  const config = await loadConfig();
  const session = await establishSession(config);

  root.render(
    <StrictMode>
      <App config={config} session={session} />
    </StrictMode>,
  );
}

start().catch((error: unknown) => {
  const message = error instanceof Error ? error.message : String(error);

  root.render(
    <div className="center">
      <div>
        <h1>Lighthouse could not start</h1>
        <p className="muted">{message}</p>
        <button className="action" onClick={() => window.location.reload()}>
          Try again
        </button>
      </div>
    </div>,
  );
});
